import type { ColumnsType } from "antd/es/table"
import dayjs from "dayjs"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { empty } from "../../../../constants/placeholders"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { ProjectStatusTag } from "../../../Project/components/ProjectStatusTag.tsx"
import { type ProjectListItem } from "../../../Projects/types/types.ts"
import { type CustomerRelatedList } from "../redux/customer-detail.types.ts"
import { CustomerRelatedCard } from "./CustomerRelatedCard.tsx"

interface CustomerRelatedProjectsProps {
  projects: CustomerRelatedList<ProjectListItem>
  onLoadMore: () => void
}

const formatDate = (value?: string | null) =>
  value ? dayjs(value).format("MMM D, YYYY") : empty

function CustomerRelatedProjects({
  projects,
  onLoadMore
}: CustomerRelatedProjectsProps) {
  const { t } = useTranslation()

  const columns: ColumnsType<ProjectListItem> = [
    {
      title: t("customerDetail.projects.columns.name"),
      dataIndex: "lead_name",
      key: "lead_name",
      render: (name: string | null, record) => (
        <Link to={RoutesPaths.project.view(record.id).overview}>
          {name || record.project_number || record.uid || empty}
        </Link>
      )
    },
    {
      title: t("customerDetail.projects.columns.status"),
      dataIndex: "project_status",
      key: "project_status",
      width: 150,
      render: (status: string | null) => <ProjectStatusTag status={status} />
    },
    {
      title: t("customerDetail.projects.columns.startDate"),
      dataIndex: "start_date",
      key: "start_date",
      width: 140,
      render: formatDate
    },
    {
      title: t("customerDetail.projects.columns.endDate"),
      dataIndex: "end_date",
      key: "end_date",
      width: 140,
      render: formatDate
    }
  ]

  return (
    <CustomerRelatedCard<ProjectListItem>
      testId={"customer-related-projects"}
      title={t("customerDetail.projects.title")}
      emptyText={t("customerDetail.projects.empty")}
      columns={columns}
      rows={projects.results}
      count={projects.count}
      next={projects.next}
      retryNext={projects.retryNext}
      loading={projects.fetching}
      onLoadMore={onLoadMore}
    />
  )
}

export { CustomerRelatedProjects }
